
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue?macro=true";
import { default as indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue?macro=true";
import { default as logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue?macro=true";
import { default as teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue?macro=true";
import { default as _91orderId_93VUmbJUzculiEWxvEb_ymmjr9irHOLxQSqylyQYcdrUoMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue?macro=true";
import { default as _91orderId_93dfQgKQkBy93VIOaQAZLUKDgu912IHq_DiiOV49rpz64Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue?macro=true";
import { default as redirectgXJYcqc6A1vczZcjLdPo2NXFdIZPEokf9HhQAJ5DkIEMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue?macro=true";
import { default as registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue?macro=true";
import { default as _91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue?macro=true";
import { default as _91tab_93ApWNVVFf0Ah8F_pRI9r8n4wXcPR1Fd9_hZF_VwqbraIMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue?macro=true";
import { default as followingPhskmldUbdhK57X2NafrNPL_Ys7LnupgOcujb0WIO2QMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue?macro=true";
import { default as not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue?macro=true";
import { default as club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue?macro=true";
import { default as indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue?macro=true";
import { default as _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue?macro=true";
import { default as verify_45email5C_iROq4G2Kg4dNxsHy8uiVCUncPoN8uUmSVu11MOM4Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue?macro=true";
import { default as auth_45redirectzD_FN3dnY61lTV0GZptz5u95G9zS7vcGqOri_MFPkUwMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue?macro=true";
import { default as _91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue?macro=true";
import { default as password_45resetj9ZskBV_2VYiD7VvqGUzt5ltC7_7O3QRTYOj67zGgFoMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue?macro=true";
import { default as following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue?macro=true";
import { default as forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue?macro=true";
import { default as browse_45countriesD21diq9dl07VuJ7UwN4xI_D1UvtIeF_f8d6wnIj0E4wMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue?macro=true";
import { default as football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue?macro=true";
import { default as indexM6HkU2ArD_2EfdHq7Ha9HzZBguQbScSwFsScM32XnSUMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue?macro=true";
import { default as _91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue?macro=true";
import { default as _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue?macro=true";
import { default as _91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue?macro=true";
import { default as _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue?macro=true";
import { default as _91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue?macro=true";
import { default as indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue?macro=true";
import { default as indexeCk35h2PKGkceGD8L2m3_5xGi2wJ0hjYoXMEikZW33UMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue?macro=true";
import { default as indexinMIWnw1zy1Uk_COzxFdA4YpQ5WmYxnR5ziGIQ4bxg8Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue?macro=true";
import { default as address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue?macro=true";
import { default as _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue?macro=true";
import { default as redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue?macro=true";
import { default as index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue?macro=true";
import { default as redirect71hGuoz8pB3T9bd5uFa0Ua_OInxFpi2Sf_59CAvrvbYMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue?macro=true";
import { default as _91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue?macro=true";
import { default as _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue?macro=true";
import { default as add_45new_45card3EZoz0Pm3RmQ6Vs2zjVcRJupc5XUnB8Cx9wZOMF1_OIMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue?macro=true";
import { default as _91certificateNumber_93cgKklG7S5ympp6OJ6I5HDChP2WBhYhCaBB1D0JG_I3AMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue?macro=true";
import { default as indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue?macro=true";
import { default as delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue?macro=true";
import { default as account_45detailsmEsTPGRSPh7KqUYorxVkCZh7u5n1NzeGpxji8l8feSEMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue?macro=true";
import { default as indexRdoe2K6dL2jjZD68P58hyX_ck1cVV7fW9iIGJ7K7xAMMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue?macro=true";
import { default as _91orderId_93ZYlRzHHUcGuVoS954UkKessmgNC8IhxcnWuDAKMIHRMMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue?macro=true";
import { default as _91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue?macro=true";
import { default as create_45new_45addressWSk9oRBlUbRJJyW__1t4RwPmt7PIdd_fguGipXUzXjMMeta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue?macro=true";
import { default as _91addressId_932griJfwH8CVaaG3xtWQL21rDq9YHSXtgjr7JT91iH94Meta } from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue?macro=true";
export default [
  {
    name: "live___en___default",
    path: "/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___en",
    path: "/en/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___us",
    path: "/us/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___nl",
    path: "/nl/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___fr",
    path: "/fr/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___de",
    path: "/de/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___it",
    path: "/it/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___es",
    path: "/es/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___pt",
    path: "/pt/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___br",
    path: "/br/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___ja",
    path: "/ja/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___zh",
    path: "/zh/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___tr",
    path: "/tr/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "live___ko",
    path: "/ko/live",
    meta: { ...(livew3a451RouY10M2_X5QNMH4Tsx_jqvCPMF0HqFtgCsUcMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/live.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___us",
    path: "/us",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___br",
    path: "/br",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    meta: { ...(indexHLPH37ognx4KEOGv_aeUQtI9heZqZemkaWJH0rFPuVEMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/index.vue")
  },
  {
    name: "login___en___default",
    path: "/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___us",
    path: "/us/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___nl",
    path: "/nl/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___it",
    path: "/it/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___pt",
    path: "/pt/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___br",
    path: "/br/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___ja",
    path: "/ja/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___zh",
    path: "/zh/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___tr",
    path: "/tr/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "login___ko",
    path: "/ko/login",
    meta: logina_u3h9_WfiwQG9qRC7QBbERDpgxOz2_I_mQ_JUnuUfEMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/login.vue")
  },
  {
    name: "teams___en___default",
    path: "/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___en",
    path: "/en/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___us",
    path: "/us/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___nl",
    path: "/nl/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___fr",
    path: "/fr/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___de",
    path: "/de/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___it",
    path: "/it/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___es",
    path: "/es/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___pt",
    path: "/pt/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___br",
    path: "/br/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___ja",
    path: "/ja/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___zh",
    path: "/zh/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___tr",
    path: "/tr/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "teams___ko",
    path: "/ko/teams",
    meta: teamsw3YvN2TGICArYOuiODWBS6sbMMtfoKw9CkSI2TlT91cMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/teams.vue")
  },
  {
    name: "redirect___en___default",
    path: "/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___en___default",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___en___default",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___en",
    path: "/en/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___en",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___en",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___us",
    path: "/us/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___us",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___us",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___nl",
    path: "/nl/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___nl",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___nl",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___fr",
    path: "/fr/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___fr",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___fr",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___de",
    path: "/de/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___de",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___de",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___it",
    path: "/it/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___it",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___it",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___es",
    path: "/es/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___es",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___es",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___pt",
    path: "/pt/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___pt",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___pt",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___br",
    path: "/br/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___br",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___br",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___ja",
    path: "/ja/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___ja",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___ja",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___zh",
    path: "/zh/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___zh",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___zh",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___tr",
    path: "/tr/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___tr",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___tr",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "redirect___ko",
    path: "/ko/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect.vue"),
    children: [
  {
    name: "redirect-frame-it-orderId___ko",
    path: "frame-it/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/frame-it/[orderId].vue")
  },
  {
    name: "redirect-direct-ship-orderId___ko",
    path: "direct-ship/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/redirect/direct-ship/[orderId].vue")
  }
]
  },
  {
    name: "register___en___default",
    path: "/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___us",
    path: "/us/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___nl",
    path: "/nl/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___it",
    path: "/it/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___es",
    path: "/es/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___pt",
    path: "/pt/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___br",
    path: "/br/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___ja",
    path: "/ja/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___zh",
    path: "/zh/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___tr",
    path: "/tr/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "register___ko",
    path: "/ko/register",
    meta: registerh8EQvCo1qQG0WsGqadtv37zOuCuf4TBbfECv3KPCAiUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/register.vue")
  },
  {
    name: "slug___en___default",
    path: "/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___us",
    path: "/us/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___pt",
    path: "/pt/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___br",
    path: "/br/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___ja",
    path: "/ja/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___zh",
    path: "/zh/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___tr",
    path: "/tr/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "slug___ko",
    path: "/ko/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93wRHzGYJ4MUVsgzwh2Gm_pe0da9QuEmJMV7hY78RqMYUMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/[...slug].vue")
  },
  {
    name: "following___en___default",
    path: "/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___en___default",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___en",
    path: "/en/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___en",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___us",
    path: "/us/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___us",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___nl",
    path: "/nl/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___nl",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___fr",
    path: "/fr/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___fr",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___de",
    path: "/de/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___de",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___it",
    path: "/it/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___it",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___es",
    path: "/es/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___es",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___pt",
    path: "/pt/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___pt",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___br",
    path: "/br/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___br",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___ja",
    path: "/ja/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___ja",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___zh",
    path: "/zh/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___zh",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___tr",
    path: "/tr/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___tr",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "following___ko",
    path: "/ko/following",
    meta: {"middleware":"following"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following.vue"),
    children: [
  {
    name: "following-tab___ko",
    path: ":tab()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following/[tab].vue")
  }
]
  },
  {
    name: "not-found___en___default",
    path: "/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___en",
    path: "/en/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___us",
    path: "/us/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___nl",
    path: "/nl/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___fr",
    path: "/fr/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___de",
    path: "/de/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___it",
    path: "/it/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___es",
    path: "/es/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___pt",
    path: "/pt/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___br",
    path: "/br/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___ja",
    path: "/ja/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___zh",
    path: "/zh/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___tr",
    path: "/tr/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "not-found___ko",
    path: "/ko/not-found",
    meta: not_45foundBHBVdiWWvkfLVaBKzKNTKwguK8smU0vir3tXSFJFHjoMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/not-found.vue")
  },
  {
    name: "club-login___en___default",
    path: "/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___en",
    path: "/en/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___us",
    path: "/us/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___nl",
    path: "/nl/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___fr",
    path: "/fr/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___de",
    path: "/de/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___it",
    path: "/it/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___es",
    path: "/es/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___pt",
    path: "/pt/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___br",
    path: "/br/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___ja",
    path: "/ja/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___zh",
    path: "/zh/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___tr",
    path: "/tr/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "club-login___ko",
    path: "/ko/club-login",
    meta: club_45logineVylWW4SVr_3InvTszgEB_caGJlMziS0DJzpWTmMvtsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/club-login.vue")
  },
  {
    name: "news___en___default",
    path: "/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___us",
    path: "/us/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___nl",
    path: "/nl/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___fr",
    path: "/fr/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___de",
    path: "/de/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___it",
    path: "/it/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___es",
    path: "/es/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___pt",
    path: "/pt/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___br",
    path: "/br/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___ja",
    path: "/ja/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___zh",
    path: "/zh/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___tr",
    path: "/tr/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news___ko",
    path: "/ko/news",
    meta: indexHhxBIK1cmsMo_L_qwEg0pIoMAzRRqcTu5dcie_lchTUMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/index.vue")
  },
  {
    name: "news-slug___en___default",
    path: "/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___en",
    path: "/en/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___us",
    path: "/us/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___nl",
    path: "/nl/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___fr",
    path: "/fr/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___de",
    path: "/de/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___it",
    path: "/it/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___es",
    path: "/es/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___pt",
    path: "/pt/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___br",
    path: "/br/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ja",
    path: "/ja/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___zh",
    path: "/zh/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___tr",
    path: "/tr/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ko",
    path: "/ko/news/:slug()",
    meta: _91slug_93QHBI0YylHLq8kavbrBzQg_KHfyGzWDat1EuIcBEMXkMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/news/[slug].vue")
  },
  {
    name: "verify-email___en___default",
    path: "/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___en",
    path: "/en/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___us",
    path: "/us/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___nl",
    path: "/nl/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___fr",
    path: "/fr/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___de",
    path: "/de/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___it",
    path: "/it/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___es",
    path: "/es/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___pt",
    path: "/pt/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___br",
    path: "/br/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___ja",
    path: "/ja/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___zh",
    path: "/zh/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___tr",
    path: "/tr/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___ko",
    path: "/ko/verify-email",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/verify-email.vue")
  },
  {
    name: "auth-redirect___en___default",
    path: "/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___en",
    path: "/en/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___us",
    path: "/us/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___nl",
    path: "/nl/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___fr",
    path: "/fr/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___de",
    path: "/de/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___it",
    path: "/it/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___es",
    path: "/es/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___pt",
    path: "/pt/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___br",
    path: "/br/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___ja",
    path: "/ja/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___zh",
    path: "/zh/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___tr",
    path: "/tr/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "auth-redirect___ko",
    path: "/ko/auth-redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/auth-redirect.vue")
  },
  {
    name: "landing-slug___en___default",
    path: "/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___en",
    path: "/en/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___us",
    path: "/us/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___nl",
    path: "/nl/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___fr",
    path: "/fr/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___de",
    path: "/de/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___it",
    path: "/it/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___es",
    path: "/es/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___pt",
    path: "/pt/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___br",
    path: "/br/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___ja",
    path: "/ja/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___zh",
    path: "/zh/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___tr",
    path: "/tr/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "landing-slug___ko",
    path: "/ko/landing/:slug()",
    meta: { ...(_91slug_93x1F4V721Muef8dGgYrSL6sEeM1YWXQI5GyaNPqEbqkoMeta || {}), ...{"middleware":["storyblok-preview-redirect","cache-control-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/landing/[slug].vue")
  },
  {
    name: "password-reset___en___default",
    path: "/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___en",
    path: "/en/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___us",
    path: "/us/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___nl",
    path: "/nl/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___fr",
    path: "/fr/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___de",
    path: "/de/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___it",
    path: "/it/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___es",
    path: "/es/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___pt",
    path: "/pt/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___br",
    path: "/br/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___ja",
    path: "/ja/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___zh",
    path: "/zh/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___tr",
    path: "/tr/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___ko",
    path: "/ko/password-reset",
    meta: {"middleware":["guest"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/password-reset.vue")
  },
  {
    name: "following-login___en___default",
    path: "/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___en",
    path: "/en/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___us",
    path: "/us/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___nl",
    path: "/nl/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___fr",
    path: "/fr/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___de",
    path: "/de/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___it",
    path: "/it/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___es",
    path: "/es/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___pt",
    path: "/pt/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___br",
    path: "/br/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___ja",
    path: "/ja/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___zh",
    path: "/zh/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___tr",
    path: "/tr/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "following-login___ko",
    path: "/ko/following-login",
    meta: following_45logincC4ZKeHMiGzTOc8ieaKQe2jRdby7i_zESaEyvSj60fgMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/following-login.vue")
  },
  {
    name: "forgot-password___en___default",
    path: "/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___us",
    path: "/us/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___nl",
    path: "/nl/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___fr",
    path: "/fr/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___de",
    path: "/de/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___it",
    path: "/it/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___es",
    path: "/es/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___pt",
    path: "/pt/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___br",
    path: "/br/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ja",
    path: "/ja/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___zh",
    path: "/zh/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___tr",
    path: "/tr/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ko",
    path: "/ko/forgot-password",
    meta: forgot_45passwordkgk41JZ87HTO9NM5Wy1i8PcGvP2ZwanOVI03HTvsaPIMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/forgot-password.vue")
  },
  {
    name: "browse-countries___en___default",
    path: "/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___en",
    path: "/en/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___us",
    path: "/us/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___nl",
    path: "/nl/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___fr",
    path: "/fr/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___de",
    path: "/de/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___it",
    path: "/it/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___es",
    path: "/es/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___pt",
    path: "/pt/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___br",
    path: "/br/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___ja",
    path: "/ja/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___zh",
    path: "/zh/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___tr",
    path: "/tr/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "browse-countries___ko",
    path: "/ko/browse-countries",
    meta: {"middleware":["cache-control-server","only-auctioning-platform"]},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/browse-countries.vue")
  },
  {
    name: "football-leagues___en___default",
    path: "/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___en",
    path: "/en/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___us",
    path: "/us/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___nl",
    path: "/nl/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___fr",
    path: "/fr/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___de",
    path: "/de/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___it",
    path: "/it/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___es",
    path: "/es/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___pt",
    path: "/pt/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___br",
    path: "/br/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___ja",
    path: "/ja/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___zh",
    path: "/zh/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___tr",
    path: "/tr/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "football-leagues___ko",
    path: "/ko/football-leagues",
    meta: { ...(football_45leaguesG7leiNdODG5n4Zi1I_m_B2HoP0zMDGDqIn5GLebaCQsMeta || {}), ...{"middleware":["cache-control-server","only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/football-leagues.vue")
  },
  {
    name: "my-account___en___default",
    path: "/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___en",
    path: "/en/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___us",
    path: "/us/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___nl",
    path: "/nl/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___fr",
    path: "/fr/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___de",
    path: "/de/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___it",
    path: "/it/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___es",
    path: "/es/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___pt",
    path: "/pt/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___br",
    path: "/br/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___ja",
    path: "/ja/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___zh",
    path: "/zh/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___tr",
    path: "/tr/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "my-account___ko",
    path: "/ko/my-account",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/index.vue")
  },
  {
    name: "event-eventSlug___en___default",
    path: "/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___en",
    path: "/en/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___us",
    path: "/us/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___nl",
    path: "/nl/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___fr",
    path: "/fr/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___de",
    path: "/de/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___it",
    path: "/it/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___es",
    path: "/es/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___pt",
    path: "/pt/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___br",
    path: "/br/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___ja",
    path: "/ja/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___zh",
    path: "/zh/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___tr",
    path: "/tr/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "event-eventSlug___ko",
    path: "/ko/event/:eventSlug()",
    meta: { ...(_91eventSlug_93S2sY6K0CJak1oO1I2lgsErr23Zrt8nFqBOeSwMG6ktsMeta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/event/[eventSlug].vue")
  },
  {
    name: "search-searchTerm___en___default",
    path: "/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___en",
    path: "/en/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___us",
    path: "/us/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___nl",
    path: "/nl/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___fr",
    path: "/fr/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___de",
    path: "/de/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___it",
    path: "/it/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___es",
    path: "/es/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___pt",
    path: "/pt/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___br",
    path: "/br/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___ja",
    path: "/ja/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___zh",
    path: "/zh/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___tr",
    path: "/tr/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "search-searchTerm___ko",
    path: "/ko/search/:searchTerm()",
    meta: _91searchTerm_9309u2iKCcHm2eV_pNacqkrJpztw1hOc97cAtc7vMPbPMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/[searchTerm].vue")
  },
  {
    name: "all-products-slug___en___default",
    path: "/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___en",
    path: "/en/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___us",
    path: "/us/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___nl",
    path: "/nl/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___fr",
    path: "/fr/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___de",
    path: "/de/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___it",
    path: "/it/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___es",
    path: "/es/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___pt",
    path: "/pt/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___br",
    path: "/br/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___ja",
    path: "/ja/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___zh",
    path: "/zh/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___tr",
    path: "/tr/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "all-products-slug___ko",
    path: "/ko/all-products/:slug?",
    meta: { ...(_91_91slug_93_93v7MkpRJb2v1SggQAYHGufk_ky_39EJBBFXbRQ_lCsUkMeta || {}), ...{"middleware":["only-auctioning-platform"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/all-products/[[slug]].vue")
  },
  {
    name: "search-category-slug___en___default",
    path: "/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___en",
    path: "/en/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___us",
    path: "/us/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___nl",
    path: "/nl/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___fr",
    path: "/fr/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___de",
    path: "/de/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___it",
    path: "/it/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___es",
    path: "/es/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___pt",
    path: "/pt/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___br",
    path: "/br/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___ja",
    path: "/ja/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___zh",
    path: "/zh/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___tr",
    path: "/tr/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "search-category-slug___ko",
    path: "/ko/search/category/:slug()",
    meta: _91slug_93ow2IapGaMdW6RkfAGODiaVwMgN3XXSkrlCGI_xz1_yMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/search/category/[slug].vue")
  },
  {
    name: "category-categorySlug___en___default",
    path: "/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___en",
    path: "/en/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___us",
    path: "/us/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___nl",
    path: "/nl/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___fr",
    path: "/fr/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___de",
    path: "/de/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___it",
    path: "/it/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___es",
    path: "/es/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___pt",
    path: "/pt/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___br",
    path: "/br/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___ja",
    path: "/ja/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___zh",
    path: "/zh/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___tr",
    path: "/tr/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "category-categorySlug___ko",
    path: "/ko/category/:categorySlug()",
    meta: { ...(_91categorySlug_93d8djLqIUMTMnYgWLxzLD8il5EuXp9vAUmj3GMAfixa4Meta || {}), ...{"middleware":["cache-control-server","whitelabel-category-filter-server"]} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/category/[categorySlug].vue")
  },
  {
    name: "checkout-orderId___en___default",
    path: "/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___en",
    path: "/en/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___us",
    path: "/us/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___nl",
    path: "/nl/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___fr",
    path: "/fr/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___de",
    path: "/de/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___it",
    path: "/it/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___es",
    path: "/es/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___pt",
    path: "/pt/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___br",
    path: "/br/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___ja",
    path: "/ja/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___zh",
    path: "/zh/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___tr",
    path: "/tr/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "checkout-orderId___ko",
    path: "/ko/checkout/:orderId()",
    meta: { ...(indexGsA6rOoeOv_Opi6nHSF3Qfbs21e28qK07F38aqmZHmoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/index.vue")
  },
  {
    name: "my-account-payment___en___default",
    path: "/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___en",
    path: "/en/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___us",
    path: "/us/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___nl",
    path: "/nl/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___fr",
    path: "/fr/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___de",
    path: "/de/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___it",
    path: "/it/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___es",
    path: "/es/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___pt",
    path: "/pt/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___br",
    path: "/br/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___ja",
    path: "/ja/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___zh",
    path: "/zh/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___tr",
    path: "/tr/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-payment___ko",
    path: "/ko/my-account/payment",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/index.vue")
  },
  {
    name: "my-account-settings___en___default",
    path: "/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___en",
    path: "/en/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___us",
    path: "/us/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___nl",
    path: "/nl/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___fr",
    path: "/fr/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___de",
    path: "/de/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___it",
    path: "/it/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___es",
    path: "/es/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___pt",
    path: "/pt/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___br",
    path: "/br/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___ja",
    path: "/ja/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___zh",
    path: "/zh/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___tr",
    path: "/tr/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "my-account-settings___ko",
    path: "/ko/my-account/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/index.vue")
  },
  {
    name: "checkout-orderId-address___en___default",
    path: "/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___en",
    path: "/en/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___us",
    path: "/us/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___nl",
    path: "/nl/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___fr",
    path: "/fr/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___de",
    path: "/de/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___it",
    path: "/it/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___es",
    path: "/es/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___pt",
    path: "/pt/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___br",
    path: "/br/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___ja",
    path: "/ja/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___zh",
    path: "/zh/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___tr",
    path: "/tr/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "checkout-orderId-address___ko",
    path: "/ko/checkout/:orderId()/address",
    meta: { ...(address2W0KKyb_2CqoPGz8egC3MUaFlqbbsodrqFlyfg_U9rkMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/address.vue")
  },
  {
    name: "my-account-my-bids-tab___en___default",
    path: "/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___en",
    path: "/en/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___us",
    path: "/us/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___nl",
    path: "/nl/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___fr",
    path: "/fr/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___de",
    path: "/de/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___it",
    path: "/it/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___es",
    path: "/es/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___pt",
    path: "/pt/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___br",
    path: "/br/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___ja",
    path: "/ja/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___zh",
    path: "/zh/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___tr",
    path: "/tr/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "my-account-my-bids-tab___ko",
    path: "/ko/my-account/my-bids/:tab?",
    meta: _91_91tab_93_93ELq9jnlrsHFePCxdfwZdqnCeD4Zmmqnm0UX15ks6R7EMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-bids/[[tab]].vue")
  },
  {
    name: "checkout-orderId-redirect___en___default",
    path: "/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___en",
    path: "/en/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___us",
    path: "/us/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___nl",
    path: "/nl/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___fr",
    path: "/fr/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___de",
    path: "/de/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___it",
    path: "/it/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___es",
    path: "/es/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___pt",
    path: "/pt/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___br",
    path: "/br/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___ja",
    path: "/ja/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___zh",
    path: "/zh/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___tr",
    path: "/tr/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "checkout-orderId-redirect___ko",
    path: "/ko/checkout/:orderId()/redirect",
    meta: { ...(redirectE1jyFg66ygHMEA6abhMXAlO4dp6ijRaelbkVcQ94XWcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/redirect.vue")
  },
  {
    name: "my-account-my-profile___en___default",
    path: "/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___en",
    path: "/en/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___us",
    path: "/us/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___nl",
    path: "/nl/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___fr",
    path: "/fr/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___de",
    path: "/de/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___it",
    path: "/it/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___es",
    path: "/es/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___pt",
    path: "/pt/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___br",
    path: "/br/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___ja",
    path: "/ja/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___zh",
    path: "/zh/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___tr",
    path: "/tr/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-my-profile___ko",
    path: "/ko/my-account/my-profile",
    meta: index_EwkVE70bW7yFwKsDcLpFCku_SiLTsoxuiswCqZdOOQMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-profile/index.vue")
  },
  {
    name: "my-account-payment-redirect___en___default",
    path: "/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___en",
    path: "/en/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___us",
    path: "/us/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___nl",
    path: "/nl/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___fr",
    path: "/fr/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___de",
    path: "/de/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___it",
    path: "/it/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___es",
    path: "/es/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___pt",
    path: "/pt/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___br",
    path: "/br/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___ja",
    path: "/ja/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___zh",
    path: "/zh/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___tr",
    path: "/tr/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "my-account-payment-redirect___ko",
    path: "/ko/my-account/payment/redirect",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/redirect.vue")
  },
  {
    name: "product-productIdentifier___en___default",
    path: "/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___en",
    path: "/en/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___us",
    path: "/us/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___nl",
    path: "/nl/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___fr",
    path: "/fr/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___de",
    path: "/de/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___it",
    path: "/it/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___es",
    path: "/es/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___pt",
    path: "/pt/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___br",
    path: "/br/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___ja",
    path: "/ja/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___zh",
    path: "/zh/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___tr",
    path: "/tr/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "product-productIdentifier___ko",
    path: "/ko/product/:productIdentifier()",
    meta: { ...(_91productIdentifier_93LfoPo4NXz7aVDGk1bOeiZgpEqjPOoJoixedCJcZIiE4Meta || {}), ...{"middleware":"cache-control-server"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/product/[productIdentifier].vue")
  },
  {
    name: "my-account-my-orders-tab___en___default",
    path: "/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___en",
    path: "/en/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___us",
    path: "/us/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___nl",
    path: "/nl/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___fr",
    path: "/fr/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___de",
    path: "/de/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___it",
    path: "/it/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___es",
    path: "/es/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___pt",
    path: "/pt/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___br",
    path: "/br/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___ja",
    path: "/ja/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___zh",
    path: "/zh/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___tr",
    path: "/tr/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-my-orders-tab___ko",
    path: "/ko/my-account/my-orders/:tab?",
    meta: _91_91tab_93_93yWBwAXTz_KtKz2ijlZ6CV3hr5YspX5487xzAkP6j6nMMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/[[tab]].vue")
  },
  {
    name: "my-account-payment-add-new-card___en___default",
    path: "/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___en",
    path: "/en/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___us",
    path: "/us/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___nl",
    path: "/nl/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___fr",
    path: "/fr/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___de",
    path: "/de/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___it",
    path: "/it/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___es",
    path: "/es/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___pt",
    path: "/pt/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___br",
    path: "/br/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___ja",
    path: "/ja/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___zh",
    path: "/zh/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___tr",
    path: "/tr/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "my-account-payment-add-new-card___ko",
    path: "/ko/my-account/payment/add-new-card",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/payment/add-new-card.vue")
  },
  {
    name: "authenticate-certificateNumber___en___default",
    path: "/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___en",
    path: "/en/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___us",
    path: "/us/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___nl",
    path: "/nl/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___fr",
    path: "/fr/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___de",
    path: "/de/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___it",
    path: "/it/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___es",
    path: "/es/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___pt",
    path: "/pt/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___br",
    path: "/br/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___ja",
    path: "/ja/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___zh",
    path: "/zh/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___tr",
    path: "/tr/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "authenticate-certificateNumber___ko",
    path: "/ko/authenticate/:certificateNumber()",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/authenticate/[certificateNumber].vue")
  },
  {
    name: "checkout-orderId-payment___en___default",
    path: "/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___en",
    path: "/en/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___us",
    path: "/us/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___nl",
    path: "/nl/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___fr",
    path: "/fr/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___de",
    path: "/de/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___it",
    path: "/it/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___es",
    path: "/es/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___pt",
    path: "/pt/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___br",
    path: "/br/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___ja",
    path: "/ja/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___zh",
    path: "/zh/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___tr",
    path: "/tr/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "checkout-orderId-payment___ko",
    path: "/ko/checkout/:orderId()/payment",
    meta: { ...(indexN9j8nF8L7HhbDJFT3sAULVExcK73ai2stV0MhY1jkXoMeta || {}), ...{"middleware":"checkout"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/index.vue")
  },
  {
    name: "my-account-settings-delete-account___en___default",
    path: "/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___en",
    path: "/en/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___us",
    path: "/us/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___nl",
    path: "/nl/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___fr",
    path: "/fr/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___de",
    path: "/de/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___it",
    path: "/it/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___es",
    path: "/es/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___pt",
    path: "/pt/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___br",
    path: "/br/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___ja",
    path: "/ja/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___zh",
    path: "/zh/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___tr",
    path: "/tr/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-delete-account___ko",
    path: "/ko/my-account/settings/delete-account",
    meta: delete_45accountHfw92Cbwh96c1icaz3BAxVqcdZ_gbmIjbRvPHUlG8QsMeta || {},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/delete-account.vue")
  },
  {
    name: "my-account-settings-account-details___en___default",
    path: "/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___en",
    path: "/en/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___us",
    path: "/us/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___nl",
    path: "/nl/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___fr",
    path: "/fr/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___de",
    path: "/de/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___it",
    path: "/it/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___es",
    path: "/es/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___pt",
    path: "/pt/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___br",
    path: "/br/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___ja",
    path: "/ja/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___zh",
    path: "/zh/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___tr",
    path: "/tr/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-account-details___ko",
    path: "/ko/my-account/settings/account-details",
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/account-details.vue")
  },
  {
    name: "my-account-settings-addresses___en___default",
    path: "/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___en",
    path: "/en/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___us",
    path: "/us/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___nl",
    path: "/nl/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___fr",
    path: "/fr/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___de",
    path: "/de/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___it",
    path: "/it/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___es",
    path: "/es/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___pt",
    path: "/pt/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___br",
    path: "/br/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___ja",
    path: "/ja/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___zh",
    path: "/zh/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___tr",
    path: "/tr/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-settings-addresses___ko",
    path: "/ko/my-account/settings/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/index.vue")
  },
  {
    name: "my-account-my-orders-order-orderId___en___default",
    path: "/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___en",
    path: "/en/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___us",
    path: "/us/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___nl",
    path: "/nl/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___fr",
    path: "/fr/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___de",
    path: "/de/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___it",
    path: "/it/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___es",
    path: "/es/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___pt",
    path: "/pt/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___br",
    path: "/br/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___ja",
    path: "/ja/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___zh",
    path: "/zh/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___tr",
    path: "/tr/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "my-account-my-orders-order-orderId___ko",
    path: "/ko/my-account/my-orders/order/:orderId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/my-orders/order/[orderId].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___en___default",
    path: "/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___en",
    path: "/en/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___us",
    path: "/us/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___nl",
    path: "/nl/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___fr",
    path: "/fr/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___de",
    path: "/de/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___it",
    path: "/it/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___es",
    path: "/es/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___pt",
    path: "/pt/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___br",
    path: "/br/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___ja",
    path: "/ja/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___zh",
    path: "/zh/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___tr",
    path: "/tr/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "checkout-orderId-payment-resultCode___ko",
    path: "/ko/checkout/:orderId()/payment/:resultCode()",
    meta: { ...(_91resultCode_93GOu_9IJhq3_rjZL0OrviK0xOutDxz4XFl8uKA2ug19YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/checkout/[orderId]/payment/[resultCode].vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___en___default",
    path: "/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___en",
    path: "/en/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___us",
    path: "/us/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___nl",
    path: "/nl/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___fr",
    path: "/fr/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___de",
    path: "/de/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___it",
    path: "/it/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___es",
    path: "/es/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___pt",
    path: "/pt/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___br",
    path: "/br/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___ja",
    path: "/ja/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___zh",
    path: "/zh/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___tr",
    path: "/tr/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-create-new-address___ko",
    path: "/ko/my-account/settings/addresses/create-new-address",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/create-new-address.vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___en___default",
    path: "/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___en",
    path: "/en/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___us",
    path: "/us/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___nl",
    path: "/nl/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___fr",
    path: "/fr/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___de",
    path: "/de/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___it",
    path: "/it/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___es",
    path: "/es/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___pt",
    path: "/pt/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___br",
    path: "/br/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___ja",
    path: "/ja/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___zh",
    path: "/zh/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___tr",
    path: "/tr/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  },
  {
    name: "my-account-settings-addresses-edit-address-addressId___ko",
    path: "/ko/my-account/settings/addresses/edit-address/:addressId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/app/pages/my-account/settings/addresses/edit-address/[addressId].vue")
  }
]